import React from "react";

import { TypeFiesta, TypeInsignia } from "@at/design-system-foundation";

import { Channel } from "@at/sauron-platform-core";

import { useChannel } from "../../../../utils/hooks/use-channel";
import * as Styled from "../charging.styles";

export const FullChargeInfoExplained = () => {
  const channel = useChannel();
  return (
    <>
      <Styled.ModalBodyStyled>
        <TypeInsignia as="h2" weight="400">
          Optimised battery charging
        </TypeInsignia>

        <TypeFiesta as="p">
          The speed of charge will slow down once the{" "}
          {channel === Channel.cars && "car"} battery reaches 80%, which helps
          protect and optimise the battery life.
        </TypeFiesta>

        <TypeFiesta as="p">
          Most people stop charging their vehicles once the battery reaches 80%
          charge.
        </TypeFiesta>
      </Styled.ModalBodyStyled>
    </>
  );
};
